import { getErrorMessage } from '@api/graphqlShopify'
import trackError from '@helpers/trackError'
import axios from 'axios'
import { z } from 'zod'
import { getApiUrl } from '@helpers/env'
import { HEADERS } from '@consts/index'

function throwAxiosError(error: unknown) {
  if (axios.isAxiosError(error) && error.response) {
    if (error.response.data?.error?.length) {
      throw new Error(error.response.data.error[0].message)
    }
  }
}

const API_URL = getApiUrl()

const CustomerEmailUpdateSchema = z.object({
  email: z.string(),
  phoneNumber: z.string().nullable().optional(),
  accessToken: z.string()
})

type EditCustomerProps = z.infer<typeof CustomerEmailUpdateSchema>
type EditCustomerResponse = EditCustomerProps & {
  permanentDomain: string
  shopId: string
  error?: {
    message: string
    field: string
  }[]
}
export async function customerEmailUpdate(payload: EditCustomerProps) {
  try {
    const result = CustomerEmailUpdateSchema.safeParse(payload)

    if (!result.success) {
      throw new Error('Invalid customer details')
    }

    const response = await axios.post<EditCustomerResponse>(
      `${API_URL}/customer/edit-customer-email`,
      {
        email: payload.email,
        shopId: process.env.SHOP_ID || '1360134207',
        permanentDomain: `${process.env.SHOP}.myshopify.com`,
        accessToken: payload.accessToken,
        ...('phoneNumber' in payload && { phone: payload.phoneNumber })
      },
      {
        headers: HEADERS
      }
    )

    return response.data
  } catch (e) {
    throwAxiosError(e)

    const errorMessage = getErrorMessage(e as Error)
    trackError(new Error(`customerEmailUpdate failed - ${errorMessage}`), {
      customer: JSON.stringify(payload),
      error: e as Error
    })
    throw e
  }
}
